import React from 'react';
import { Typography, Box, Grid, ListItemButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import makeStyles from './styles';
import { AppState } from '../../../../store';
import { callHomingService } from '../../../../store/devices/actions';
import { Result } from '../../../../store/search/types';

type DeviceList = {
  option: any;
  page?: string;
  clearSearch: Function;
  selectDeviceCallback?: Function;
};
const DeviceList = ({ option, page, clearSearch, selectDeviceCallback }: DeviceList) => {
  const sessionHistory: any | undefined = useSelector(
    (state: AppState) => state.userPreference.sessionHistory,
  );
  const results: Result[] = useSelector((state: AppState) => state.search.result);

  const device = results[option['data-option-index']];

  const classes = makeStyles();
  const dispatch = useDispatch();
  const handleSelectDevice = () => {
    if (selectDeviceCallback)
      selectDeviceCallback({
        make: device.assetMake,
        equipmentSN: device.assetSerialNumber,
        deviceId: device.deviceId,
      });
    else if (page === "vims-transactions") {
      let queryString = sessionHistory && sessionHistory[page]?.queryString ? sessionHistory[page]?.queryString : '';
      let queryFilter: string[] = [];
      queryString.split('&').forEach((parameter: string) => {
        if (!parameter.includes('dealerCode=')) queryFilter.push(parameter);
      });
      if (device.dealer) {
        queryFilter.push(`dealerCode=${device.dealerCode}`);
      }
      if ((!device.deviceId && !device.deviceKey) && device.telematicsAssetId) {
        if (queryFilter && (!queryFilter.includes('vimsData=true') && !queryFilter.includes('vimsTransaction=true')
          && !queryFilter.includes('startTime'))) {
          queryFilter.push('vimsData=true', 'vimsTransaction=true', 'startTime');
        }
      } else {
        queryFilter = queryFilter.filter(v => v !== 'vimsTransaction=true');
        queryFilter = queryFilter.filter(v => v !== 'vimsData=true');
      }
      queryString = queryFilter.length > 0 ? `?${queryFilter.join('&')}` : '';

      const removedDuplicateParameters = queryString.split("?");
      queryString = `?${removedDuplicateParameters[removedDuplicateParameters.length - 1]}`;
      const proposedRoute = `/${page}/${device.telematicsAssetId}${queryString}`;

      dispatch(callHomingService(device.deviceKey, page, proposedRoute, device));
    }
    else if (page) {
      let queryString =
        sessionHistory && sessionHistory[page]?.queryString
          ? sessionHistory[page]?.queryString
          : '';
      let queryFilter: string[] = [];
      queryString.split('&').forEach((parameter: string) => {
        if (!parameter.includes('dealerCode=')) queryFilter.push(parameter);
      });
      if (device.dealer) {
        queryFilter.push(`dealerCode=${device.dealerCode}`);
      }
      if ((!device.deviceId && !device.deviceKey) && device.telematicsAssetId) {
        queryFilter.push('vimsData=true');
      } else {
        queryFilter = queryFilter.filter(v => v !== 'vimsData=true');
      }
      queryString = queryFilter.length > 0 ? `?${queryFilter.join('&')}` : '';

      const removedDuplicateParameters = queryString.split("?");
      queryString = `?${removedDuplicateParameters[removedDuplicateParameters.length - 1]}`
      const proposedRoute =
        page === 'transactions' || device?.dealerCode
          ? `/${page}/${device.deviceId || device.telematicsAssetId}${queryString}`
          : `${device.deviceId || device.telematicsAssetId}${queryString}`;

      dispatch(callHomingService(device.deviceKey, page, proposedRoute, device));
    }
    clearSearch();
  };

  return (
    <ListItemButton onClick={() => handleSelectDevice()}>
      <Grid direction="row" justifyContent="space-around" alignItems="center" container spacing={3}>
        <Grid item xs={4}>
          <Box display="flex" flexDirection="column">
            <Typography className={classes.boldText} noWrap>
              {device.equipmentType || device.assetMake}
            </Typography>
            <Typography noWrap>{device.assetSerialNumber}</Typography>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box display="flex" flexDirection="column">
            <Typography className={classes.boldText} noWrap>
              {device.moduleType}
            </Typography>
            <Typography noWrap>{device.moduleId || `No Device`}</Typography>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box display="flex" flexDirection="column">
            <Typography className={classes.boldText} noWrap>
              {device.deviceId}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </ListItemButton>
  );
};

export default DeviceList;
